module.exports = __webpack_public_path__ + "img/partners-2.aa8e14d1.jpg";